<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout v-if="Boolean(selectedCompany)" align-center row>
      <v-spacer />

      <a
        v-if="claims.timePolicy['ROLE_GET_TIMEPOLICY_BYPASS']"
        href="#"
        :title="$t(`${namespace}.exceptionList`)"
        class="action-bar__link"
        @click.prevent="handleExceptionList"
      >
        {{ $t(`${namespace}.exceptionList`) }}
      </a>

      <v-btn
        v-if="claims.timePolicy['ROLE_POST_TIMEPOLICY']"
        :to="{
          name: 'UsagePolicy',
          params: { type: 'cadastrar' }
        }"
        class="action-bar__btn"
        color="accent"
        round
        depressed
      >
        {{ $t(`${namespace}.addUsagePolicy`) }}
      </v-btn>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.UsagePoliciesPage',
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'UsagePolicies', title: this.$t('Views.UsagePoliciesPage.title') }
      ]
    }
  },
  methods: {
    handleExceptionList () {
      this.$emit('exceptionList')
    }
  }
}
</script>
